import React from "react";
import MainSection from "../MainSection";
import {convertJSONintoPreferredFormat} from "../../utils/mainSectionUtils";
const ApiDetailHeader = ({
  name,
  description,
  paths,
  entityIndex,
  subEntityIndex,
  navIndex,
  id,
  schemas,
}) => {
  return (
    <>
      <div className="main-section">
        <h1 className="header" id={`${id}`} data-menu-index={entityIndex} data-subMenu-index={subEntityIndex} data-open-index={navIndex} data-id={name}>
          {name}
        </h1>
        <p className="header1-description">{description}</p>
      </div>
      {paths.map(({name, method, id}, activeIndex) => {
        return (
          <>
            <MainSection
              id={id}
              menuIndex={entityIndex}
              subMenuIndex={subEntityIndex}
              index={activeIndex}
              key={`${name}+${activeIndex}`}
              currMethod={method}
              navIndex={navIndex}
              {...convertJSONintoPreferredFormat(name, method, schemas)}
            />
          </>
        );
      })}
    </>
  );
};

export default ApiDetailHeader;
